import appConfig from '@/appConfig';
import requestManager from '@/components/platformApi/requestManager';

export default {
    
    /**
     * @param {Function} callback(list)
     */
    getEducationBackgroundList(callback) {
        requestManager.request({
            url : appConfig.apiBaseUrl + 'portal/recruit/seeker/get/educationBackground'
        }, (error, result) => {
            if (error || result.errorCode)
            {
                return;
            }
            
            callback(result.data);
        });
    },
    
    /**
     * @param {Function} callback(list)
     */
    getEducationCertificateList(callback) {
        requestManager.request({
            url : appConfig.apiBaseUrl + 'portal/recruit/seeker/get/educationCertificate'
        }, (error, result) => {
            if (error || result.errorCode)
            {
                return;
            }
            
            callback(result.data);
        });
    }
    
}
